var _excluded = ["id", "options", "label", "onChange", "value", "renderOptions", "isSearchable", "isClearable", "selectWidth", "error", "errorMessage", "multiSelectedText", "isMulti", "withCheckBox"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import RSelect, { components } from 'react-select';
import { StyledSelectLabel, SelectWrapper, Wrapper, customStyles, ErrorMessage, StyledRemoveIcon, TagListWrapper, TagWrapper } from './style';
import { CheckIcon, CheckBoxCheckedIcon, CheckBoxUnCheckedIcon, CrossIcon } from '../Icons';
import Icon from '../Icon';
var CustomValueContainer = function CustomValueContainer(props) {
  var getValue = props.getValue,
    hasValue = props.hasValue,
    isMulti = props.isMulti,
    children = props.children,
    selectProps = props.selectProps;
  var newChildren = _toConsumableArray(children);
  var checkValuesLength = function checkValuesLength() {
    return getValue().length > 1;
  };
  var getLabel = function getLabel() {
    return getValue()[0] && getValue()[0].label;
  };
  newChildren[0] = "".concat(checkValuesLength() ? "".concat(getValue().length, " ").concat(selectProps.multiSelectedText) : getLabel());
  if (!hasValue || !isMulti) {
    return /*#__PURE__*/React.createElement(components.ValueContainer, props, children);
  }
  return /*#__PURE__*/React.createElement(components.ValueContainer, props, newChildren);
};
export var CustomOption = function CustomOption(props) {
  var _useContext = useContext(ThemeContext),
    colors = _useContext.colors;
  var Option = components.Option;
  var data = props.data,
    isSelected = props.isSelected,
    selectProps = props.selectProps;
  var _ref = selectProps || false,
    withCheckBox = _ref.withCheckBox;
  return /*#__PURE__*/React.createElement(Option, props, data.label, isSelected && !withCheckBox && /*#__PURE__*/React.createElement(Icon, {
    as: CheckIcon,
    size: "sz16",
    color: colors["default"].gray
  }), !isSelected && withCheckBox && /*#__PURE__*/React.createElement(Icon, {
    as: CheckBoxUnCheckedIcon,
    size: "sz16",
    color: colors["default"].white,
    strokeWidth: 1
  }), isSelected && withCheckBox && /*#__PURE__*/React.createElement(Icon, {
    as: CheckBoxCheckedIcon,
    size: "sz16",
    color: colors["default"].white,
    strokeWidth: 1
  }));
};
var ReactSelect = function ReactSelect(_ref2) {
  var id = _ref2.id,
    options = _ref2.options,
    label = _ref2.label,
    onChange = _ref2.onChange,
    value = _ref2.value,
    renderOptions = _ref2.renderOptions,
    isSearchable = _ref2.isSearchable,
    isClearable = _ref2.isClearable,
    selectWidth = _ref2.selectWidth,
    error = _ref2.error,
    errorMessage = _ref2.errorMessage,
    multiSelectedText = _ref2.multiSelectedText,
    isMulti = _ref2.isMulti,
    withCheckBox = _ref2.withCheckBox,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var themeContext = useContext(ThemeContext);
  var onTagClick = function onTagClick(tag) {
    return onChange(value.filter(function (item) {
      return item.value !== tag;
    }));
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    selectWidth: selectWidth
  }, label && /*#__PURE__*/React.createElement(StyledSelectLabel, {
    htmlFor: id
  }, label), /*#__PURE__*/React.createElement(SelectWrapper, null, /*#__PURE__*/React.createElement(RSelect, _extends({
    id: id,
    themeContext: themeContext,
    "data-hj-whitelist": true,
    "data-testid": id,
    styles: customStyles,
    value: value,
    onChange: onChange,
    isClearable: isClearable,
    isSearchable: isSearchable,
    closeMenuOnSelect: !isMulti,
    options: options.map(function (option) {
      return renderOptions(option);
    }),
    hideSelectedOptions: false,
    multiSelectedText: multiSelectedText,
    withCheckBox: withCheckBox,
    components: {
      Option: CustomOption,
      ValueContainer: CustomValueContainer
    },
    error: error,
    isMulti: isMulti
  }, rest)), error && /*#__PURE__*/React.createElement(ErrorMessage, {
    "data-testid": "".concat(id, "-validation-message")
  }, errorMessage), isMulti && value && value.length > 1 && /*#__PURE__*/React.createElement(TagListWrapper, null, value.map(function (tagItem) {
    return /*#__PURE__*/React.createElement(TagWrapper, {
      key: tagItem.value,
      onClick: function onClick() {
        return onTagClick(tagItem.value);
      }
    }, tagItem.label, ' ', /*#__PURE__*/React.createElement(StyledRemoveIcon, null, /*#__PURE__*/React.createElement(Icon, {
      as: CrossIcon,
      size: "sz16",
      color: themeContext.colors["default"].white
    })));
  }))));
};
var OptionPropTypes = PropTypes.shape({
  value: PropTypes.string,
  label: PropTypes.string
});
ReactSelect.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  label: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([OptionPropTypes, PropTypes.arrayOf(OptionPropTypes)]),
  renderOptions: PropTypes.func.isRequired,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  selectWidth: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.node,
  isMulti: PropTypes.bool,
  multiSelectedText: PropTypes.string
};
ReactSelect.defaultProps = {
  options: [],
  label: null,
  isSearchable: true,
  isClearable: true,
  selectWidth: null,
  error: false,
  errorMessage: null,
  value: null,
  isMulti: false,
  multiSelectedText: 'Selected'
};
export default ReactSelect;